export default "__VITE_ASSET__kT6wM3dt__"